var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-frame"},[_c('Challenge',{attrs:{"challenge":_vm.challenge}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }